// extracted by mini-css-extract-plugin
export var article = "article-module--article--4fcad";
export var image = "article-module--image--7d416";
export var wrapper = "article-module--wrapper--d9d07";